export default "__VITE_ASSET__CKcvg1gO__"